import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PosTakePhotoComponent } from 'src/app/shared/pos-take-photo/pos-take-photo.component';
import { ModalDialogType } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class PosTakePhotoModalService {
  private modalRef?: BsModalRef<PosTakePhotoComponent>;
  constructor(private modalService: BsModalService) {
    this.modalService.config.backdrop = 'static';
  }

  show():Promise<string> | undefined{
    this.modalRef = this.modalService.show(PosTakePhotoComponent, {
      class: `modal-dialog modal-md ${ModalDialogType.PRIMARY}`
    });

    return this.modalRef.content?.pictureTakenEmitter.toPromise();
  }
}
